const MapLayer = {
	SATELLITE_TILES: "satellite",

	// Alerts
	VESSELS_LIVE: "live-vessels",
	VESSELS_HISTORY_LINES: "historic-lines",
	VESSELS_HISTORY_POINTS: "historic-points",
	VESSELS_LIVE_NEARBY_BOUNDS: "vessels-live-nearby-bounds",

	// Historic Query
	HEATMAP: "vessels-heatmap",
	HEATMAP_POINTS: "vessels-heatmap-points",
	HEATMAP_LINES: "vessels-heatmap-lines",
	HIGHLIGHT_LINES: "highlight-lines",
	VESSEL_HISTORY_SNAPSHOT: "historic-snapshot",

	AIRCRAFT_FAKE_LIVE: "aircraft-fake-live",
	AIRCRAFT_FAKE_HISTORIC_LINES: "aircraft-fake-historic-lines",
	AIRCRAFT_FAKE_HISTORIC_POINTS: "aircraft-fake-historic-points",

	AIRCRAFT_ALERTS: "aircraft-alerts-live",
	AIRCRAFT_ALERTS_LINES: "aircraft-alerts-lines",
	AIRCRAFT_ALERTS_POINTS: "aircraft-alerts-points",

	AIRCRAFT_HISTORY_LINES: "aircraft-history-lines",
	AIRCRAFT_HISTORY_POINTS: "aircraft-history-points",
	AIRCRAFT_HISTORY_SNAPSHOT: "aircraft-history-snapshot",
	AIRCRAFT_HISTORY_HEATMAP: "aircraft-history-heatmap",

	ENVIRONMENT_LINES: "environment-lines",
	ENVIRONMENT_LABELS: "environment-labels",

	MEASURE_POINTS: "measure-points",
	MEASURE_POINT_LINES: "measure-lines",
	MEASURE_LABELS: "measure-labels",

	ROUTEPLOT_POINTS: "routeplot-points",
	ROUTEPLOT_POINT_LINES: "routeplot-lines",
	ROUTEPLOT_LABELS: "routeplot-labels",

	CUSTOM_GEOJSON_FILLS: "custom-geojson-fills",
	CUSTOM_GEOJSON_LINES: "custom-geojson-lines",

	CUSTOM_DRAW_LINES: "draw-polyline-lines", // Outlines
	CUSTOM_DRAW_LINES_POINTS: "draw-polyline-points", // Placement & edit points
	CUSTOM_DRAW_LINES_FILLS: "draw-polyline-fills", // Fill opacity

	SANCTIONS_POLYGONS: "sanctions-polygons",

	VESSEL_FOCUSED: "vessel-focused",

	TIMEZONE: "timezone-overlay",
	TIMEZONE_NAMES: "timezone-names",
	TIMEZONE_LINES: "timezone-lines",

	// Vessels Nearby
	VESSELS_NEARBY: "vessels_nearby",
	VESSELS_NEARBY_LINES: "vessels_nearby_lines",

	MDA_SATCAP: "mda_satcap",
	NATIONALGRID_UNDERSEA_CABLE_LINES: "ng_undersea_cable_lines",
	NATIONALGRID_UNDERSEA_CABLE_BUFFERS: "ng_undersea_cable_buffers",
	NATIONALGRID_UNDERSEA_CABLE_POINTS: "ng_undersea_cable_points",

	CLEOS_SATRF_VESSELS: "cleos_satellite_rf_vessels",
	CLEOS_SATRF: "cleos_satellite_rf"
};
export default MapLayer;
